import React from 'react';
import { Modal, Form, Input, Select, Divider, Button } from 'antd';
import { PlusOutlined, SwapOutlined } from '@ant-design/icons';

const BatchAssignModal = ({
  visible,
  onCancel,
  onOk,
  loading,
  airwayBills,
  selectedAirwayBill,
  newAirwayBillNumber,
  onAirwayBillSelect,
  onNewAirwayBillChange,
  onCreateAndAssign,
}) => {
  return (
    <Modal
      title={
        <span>
          <SwapOutlined style={{ marginRight: 8 }} />
          分配空运单
        </span>
      }
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
    >
      <Form layout="vertical">
        <Form.Item label="创建新空运单">
          <Input
            placeholder="输入新空运单号"
            value={newAirwayBillNumber}
            onChange={(e) => {
              // Remove all spaces from the input value, including spaces between numbers
              const value = e.target.value.replace(/\s+/g, '');
              onNewAirwayBillChange(value);
            }}
            suffix={
              <Button
                type="link"
                icon={<PlusOutlined />}
                onClick={onCreateAndAssign}
              >
                创建并分配
              </Button>
            }
          />
        </Form.Item>

        <Divider>或</Divider>

        <Form.Item label="选择现有空运单">
          <Select
            style={{ width: '100%' }}
            placeholder="选择空运单"
            onChange={onAirwayBillSelect}
            value={selectedAirwayBill}
            loading={loading}
            allowClear
          >
            {airwayBills.map(bill => (
              <Select.Option key={bill.id} value={bill.id}>
                {bill.airway_bill_number}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default BatchAssignModal;
